import Sifra from '../../../../../shared/components/Sifra';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { formatPrice } from '../../../../../utils/FormatPrice';

const GridProvider = ({
  data,
  isLoading,
  handleClickDokument,
  handleOpenZahtev,
}) => {
  const columns = [
    // { field: 'ceoBrDok', headerName: 'Radni nalog', width: 200 },
    {
      field: 'ceoBrDok',
      headerName: 'Broj dok.',
      width: 100,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickDokument(e.row)}
        />
      ),
    },
    {
      field: 'servisniZahtev',
      headerName: 'Zahtev za servis',
      width: 120,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleOpenZahtev(e.row.idZahteva)}
        />
      ),
    },
    { field: 'nazivKupca', headerName: 'Kupac', width: 200 },
    { field: 'nazivMasine', headerName: 'Robot/Alat', width: 200 },
    {
      field: 'Datum',
      headerName: 'Datum prijave',

      width: 110,
      renderCell: (e) => formatDateFromDB(e.row.Datum),
    },

    {
      field: 'dobitZaposleni',
      headerName: 'Usluge',
      width: 100,
      align: 'right',
      renderCell: (params) => <span>{formatPrice(params.value)}</span>,
    },
    {
      field: 'dobitZaposleniTr',
      headerName: 'Transport',
      width: 100,
      align: 'right',
      renderCell: (params) => <span>{formatPrice(params.value)}</span>,
    },
    {
      field: 'dobitDelovi',
      headerName: 'Delovi',
      width: 100,
      align: 'right',
      renderCell: (params) => <span>{formatPrice(params.value)}</span>,
    },
    {
      field: 'dobitTrosak',
      headerName: 'Troškovi',
      width: 100,
      align: 'right',
      renderCell: (params) => <span>{formatPrice(params.value)}</span>,
    },
    {
      field: 'ukupnaDobit',
      headerName: 'Ukupno',
      width: 100,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold' }}>{formatPrice(params.value)}</span>
      ),
    },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
